import { render, staticRenderFns } from "./firebase_todo.vue?vue&type=template&id=2285f441"
import script from "./firebase_todo.vue?vue&type=script&lang=js"
export * from "./firebase_todo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports